import { Component } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import * as moment from 'moment';
import { DateFormat, StorageKeyNamesCommon } from 'src/app/constants';
import { StorageService } from 'src/app/shared/services/storage.service';
import { SharedService } from 'src/app/shared/shared.service';
import { UpdatedFilterComponent } from '../../custom-filters/audit-logs/updated-filter/updated-filter.component';
import { WfNameFilterComponent } from '../../custom-filters/wf-logs/wf-name-filter/wf-name-filter.component';
import { WfStatusFilterComponent } from '../../custom-filters/wf-logs/wf-status-filter/wf-status-filter.component';
import { WfTaskFilterComponent } from '../../custom-filters/wf-logs/wf-task-filter/wf-task-filter.component';
import { ServerSideGridBase, UrlParam } from '../server-side-grid.base';
import { WflogsTooltip } from './wflogs-tooltip.component';

@Component({
  selector: 'app-wf-logs',
  templateUrl: './wf-logs.component.html',
  styleUrls: ['./wf-logs.component.scss'],
})
export class WfLogsComponent extends ServerSideGridBase {

  protected storageKey = StorageKeyNamesCommon.wfLogs;
  protected gridIdSuffix = 'wflogsGrid';

  protected override extraStaticParams: UrlParam[] = [
    { paramLabel: 'include-related', paramValue: 'true' },
  ];

  protected initialFilters = {
    'workflow-name': '',
    'partner-name': '',
    'app-name': '',
    'status': '',
    'start-date-utc': '',
    'end-date-utc': '',
  };

  protected initialSorts = {
    workflow_name: '',
    partner_name: '',
    app_name: '',
    status: '',
    created_datetime_utc: '',
  };

  override defaultColDef: ColDef = {
    sortable: true,
    comparator: () => 0,
    filter: false,
    headerTooltip: '',
    tooltipComponent: WflogsTooltip,
    tooltipField: 'payload',
    cellDataType: false,
    flex: 1,
  };

  columnDefs: ColDef[] = [
    {
      headerName: 'Workflow Name',
      field: 'workflow_name',
      filter: 'wfNameFilter',
    },
    {
      headerName: 'Status',
      field: 'status',
      filter: 'wfStatusFilter',
      headerClass: 'header-label-center',
      cellRenderer: (params: any) => {
        const a = document.createElement('div');
        a.className = 'text-center fixed-badge';
        const b = document.createElement('span');
        const state = params.data.status;
        b.className = 'badge';
        if (state === 'COMPLETE') {
          b.classList.add('btn-custom-success');
        } else if (state === 'PENDING') {
          b.classList.add('btn-custom-warning');
        } else {
          b.classList.add('btn-custom-danger');
        }
        b.innerHTML = state;
        a.appendChild(b);
        return a;
      },
    },
    {
      headerName: 'CSP Name',
      field: 'partner_name',
      filter: 'wfNameFilter',
    },
    {
      headerName: 'App Name',
      field: 'app_name',
      filter: 'wfNameFilter',
    },
    {
      headerName: 'Error Message',
      field: 'error_message',
      sortable: false,
      minWidth: 210,
    },
    {
      headerName: 'Created On',
      minWidth: 210,
      field: 'created_datetime_utc',
      filter: 'updatedFilter',
      valueGetter: params => {
        return moment.utc(params.data.created_datetime_utc).local().format(DateFormat.formatA);
      },
    },
  ];

  frameworkComponents = {
    wfNameFilter: WfNameFilterComponent,
    wfTaskFilter: WfTaskFilterComponent,
    wfStatusFilter: WfStatusFilterComponent,
    updatedFilter: UpdatedFilterComponent,
  };

  constructor(storageService: StorageService, sharedService: SharedService) {
    super(storageService, sharedService);
  }

  protected mapFilterModel(filterModel: any): void {
    this.urlParams.filters['workflow-name'] = filterModel.workflow_name ? filterModel.workflow_name.value : '';
    this.urlParams.filters['partner-name'] = filterModel.partner_name ? filterModel.partner_name.value : '';
    this.urlParams.filters['app-name'] = filterModel.app_name ? filterModel.app_name.value : '';
    this.urlParams.filters['status'] = filterModel.status ? filterModel.status.value : '';

    if (filterModel.created_datetime_utc) {
      const f = filterModel.created_datetime_utc.value.from;
      const t = filterModel.created_datetime_utc.value.to;
      const start = `${f.year}-${f.month}-${f.day}`;
      const end = `${t.year}-${t.month}-${t.day}`;
      this.urlParams.filters['start-date-utc'] = moment.utc(start).format();
      this.urlParams.filters['end-date-utc'] = moment.utc(end).format();
    } else {
      this.urlParams.filters['start-date-utc'] = '';
      this.urlParams.filters['end-date-utc'] = '';
    }
  }

  protected mapSortModel(sortModel: any[]): void {
    Object.keys(this.urlParams.sorts).forEach(k => (this.urlParams.sorts[k] = ''));
    sortModel.forEach((elem: any) => {
      if (elem.colId in this.urlParams.sorts) {
        this.urlParams.sorts[elem.colId] = elem.sort;
      }
    });
  }
}
